import {EmbedCodeExtractor} from "./types"

/**
 * Patterns of Tik::WebEmbedService::PreProcessor::FacebookIframe
 * (backend/mediaservice/lib/tik/web_embed_service/pre_processor/facebook_iframe.rb).
 *
 * Sample input:
 *   <iframe src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2FChannelNewsAsia%2Fposts%2Fpfbid0266HkPfJz9AEBTbgWQK439EMtbyLnnumu4hqMFhdG5szhNXHMCLd2iiPN1UWGCTpwl&show_text=true&width=500" width="500" height="506" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
 *
 * The third Ruby pattern starts with `^`, which in Ruby is always line-anchored —
 * the JS `m` flag restores that semantic.
 */
const PATTERNS = [
  /<iframe.*src=['"]http(?:s)?:\/\/www.facebook.com\/plugins\/post\.php\?.*href=([\w%.]+)&/i,
  /<iframe.*src=['"]http(?:s)?:\/\/www.facebook.com\/plugins\/video\.php\?.*href=([\w%.]+)&/i,
  /^http(?:s)?:\/\/www.facebook.com\/plugins\/post\.php\?href=([\w%.]+)&/im
]

/**
 * Port of Ruby CGI.unescape used by FacebookIframe#process: `+` becomes a space and
 * runs of valid `%XX` escapes are percent-decoded; invalid escape sequences are kept
 * as-is (bare decodeURIComponent would throw a URIError on them).
 *
 * NOTE: this decodeURIComponent-based variant intentionally differs from the shared
 * `cgiUnescape` (it keeps a whole invalid run untouched instead of decoding per byte) —
 * preserved exactly as ported from the Ruby service.
 */
function cgiUnescape(value: string): string {
  return value.replace(/\+/g, " ").replace(/(?:%[0-9a-fA-F]{2})+/g, (encoded) => {
    try {
      return decodeURIComponent(encoded)
    } catch {
      return encoded
    }
  })
}

/** Port of PreProcessor::FacebookIframe — unescapes the `href` parameter of Facebook plugin post/video iframes. */
export const facebookIframePreProcessor: EmbedCodeExtractor = (input: string): string | null => {
  for(const pattern of PATTERNS) {
    const matchData = pattern.exec(input)
    if(matchData) {
      return cgiUnescape(matchData[1] ?? "")
    }
  }
  return null
}
